module.exports = __webpack_public_path__ + "img/vmware.a1919b84.svg";